import { useEffect, useRef, useState } from "react";
import { Alert, Button, Card, CircularProgress, Typography } from "@mui/material";
import jwtService from "../services/jwtService";
import { clearPendingAccountLinkToken, getPendingAccountLinkToken } from "./accountAccessLink";

export default function AccountAccessPage() {
    const started = useRef(false);
    const [error, setError] = useState("");
    useEffect(() => {
        if (started.current) return; started.current = true;
        const token = getPendingAccountLinkToken(); clearPendingAccountLinkToken();
        if (!token) { setError("This link is unavailable. Open the original email link, sign in normally, or contact Peeva support."); return; }
        fetch(`${process.env.VITE_APP_API_BASE_URL}AccountAccess/open`, {
            method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ token }),
            cache: "no-store", referrerPolicy: "no-referrer"
        }).then(async response => {
            if (!response.ok) throw new Error();
            const body = await response.json();
            if (!body.succeeded || !body.result?.token) throw new Error();
            jwtService.acceptAccountLinkSession(body.result.token);
            window.location.replace("/client/account");
        }).catch(() => setError("This link is unavailable or expired. Sign in normally or contact Peeva support for a new link."));
    }, []);
    return <Card className="m-20 p-28 max-w-lg mx-auto">
        <Typography variant="h5">Your Peeva account</Typography>
        {error ? <><Alert severity="warning" className="my-16">{error}</Alert><Button href="/sign-in">Sign in normally</Button></>
            : <div role="status" className="py-24"><CircularProgress aria-label="Opening your secure account" /><Typography>Opening your account securely…</Typography></div>}
    </Card>;
}
